module.exports = __webpack_public_path__ + "img/noke-pin-mobile.5f4cc7ea.png";